import { motion } from "framer-motion";

import Card from "../../Card/Card";
import Container from "../../Container/Container";
import IconBox from "../../IconBox/IconBox";
import SectionTitle from "../../SectionTitle/SectionTitle";
import { fadeUp, staggerContainer, viewportOnce } from "../../../Utils/animations";
import { getIcon } from "../../../Utils/iconMap";
import { whyChooseUs } from "../../../Data/whyChooseData";

import "../../../Style/home/whyChooseUs.css";

function WhyChooseUs() {
  return (
    <section className="section section--plain why-choose">
      <Container>
        <SectionTitle
          eyebrow="Why Conectify Tech"
          title="Why businesses choose"
          highlight="Conectify Tech."
          align="center"
        />

        <motion.div
          className="card-grid card-grid--3"
          variants={staggerContainer(0.08)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          {whyChooseUs.map((item) => (
            <Card key={item.id} interactive variants={fadeUp()} className="why-choose__card">
              <IconBox icon={getIcon(item.icon)} variant="solid" />
              <h3 className="card__title mt-5">{item.title}</h3>
              <p className="card__text">{item.text}</p>
            </Card>
          ))}
        </motion.div>
      </Container>
    </section>
  );
}

export default WhyChooseUs;
